import * as z from "zod";

/** `missing` narrows to variants short a field the team's lanes require;
 * `returned` is every recently-returned variant, filled or not. */
export const InternationalCustomsExportScope = z.enum(["missing", "returned"]);
export type InternationalCustomsExportScope = z.infer<
  typeof InternationalCustomsExportScope
>;

export const exportInternationalCustomsCsv = {
  name: "exportInternationalCustomsCsv" as const,
  input: z.object({ scope: InternationalCustomsExportScope }),
  output: z.object({
    /** Short-lived signed URL for the generated file. */
    url: z.string(),
    rowCount: z.number().int().nonnegative(),
    /** More rows remain; the file holds the first rowCount of them. */
    truncated: z.boolean(),
  }),
};
